(function () {
  'use strict';
  var dialog = document.querySelector('[data-sample-reader]');
  if (!dialog || !dialog.showModal) return;
  var scroller = dialog.querySelector('[data-sample-scroll]');
  var pages = Array.prototype.slice.call(dialog.querySelectorAll('[data-sample-page]'));
  var counter = dialog.querySelector('[data-sample-count]');
  var opener = null, frame = 0;
  function updatePage() {
    frame = 0;
    if (!dialog.open || !pages.length) return;
    var line = scroller.getBoundingClientRect().top + 80;
    var low = 0, high = pages.length - 1, found = 0;
    while (low <= high) {
      var middle = Math.floor((low + high) / 2);
      if (pages[middle].getBoundingClientRect().top <= line) { found = middle; low = middle + 1; }
      else high = middle - 1;
    }
    counter.textContent = found + 1;
  }
  function schedule() { if (!frame) frame = requestAnimationFrame(updatePage); }
  function open(button) { opener = button; if (!dialog.open) dialog.showModal(); schedule(); }
  document.querySelectorAll('[data-open-sample]').forEach(function (button) {
    button.addEventListener('click', function (event) { event.preventDefault(); open(button); });
  });
  // Tap a page to see it larger (useful on phones); tap again to fit it back.
  dialog.querySelectorAll('[data-sample-zoom]').forEach(function (button) {
    button.addEventListener('click', function () {
      var sheet = button.parentNode;
      var zoomed = sheet.classList.toggle('is-zoomed');
      button.setAttribute('aria-pressed', zoomed ? 'true' : 'false');
      if (zoomed) sheet.scrollLeft = 0;
      schedule();
    });
  });
  dialog.querySelector('[data-close-sample]').addEventListener('click', function () { dialog.close(); });
  dialog.addEventListener('close', function () { cancelAnimationFrame(frame); frame = 0; if (opener) opener.focus({ preventScroll: true }); });
  scroller.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  // Warm the first pages so the cover appears immediately when the reader opens.
  function warm() {
    var connection = navigator.connection;
    if (connection && (connection.saveData || /(^|-)2g$/.test(connection.effectiveType))) return;
    pages.slice(0, 3).forEach(function (page) { var img = page.querySelector('img'); if (img) { var pre = new Image(); pre.src = img.currentSrc || img.src; } });
  }
  if (document.readyState === 'complete') warm();
  else window.addEventListener('load', function () { setTimeout(warm, 800); }, { once: true });
})();
